import React from "react";
import Layout from "Components/Layouts/Common/common";
import AboutClasses from "./planning.module.css";
import About3 from "Assets/taxplanning/taxplanning_2.png";
import Image1 from "Assets/taxplanning/taxplanning_1.png";
import About_2 from "Assets/About/about_2.png";
import AboutCard from "Components/AboutUs/Cards/Cards";

function About() {
    return (
        <Layout>
            <div className={AboutClasses["Container"]}>
                <header>
                    <h3>Advance Tax Planning</h3>
                </header>

                <div className={AboutClasses["section-1"]}>
                    <div className={AboutClasses["content"]}>
                        <p>
                            Tax preparation does not come easy even when it
                            comes to filling a simple return. With Serene Tax ,
                            you will benefit in learning that with our
                            expertise, we do not let you miss out on deductions
                            and credits which you are entitled and are allowed
                            by the tax code. <br />
                            <br />
                            Tax Planning is critical to a healthy financial
                            life. Certain tax impacts and substantial tax
                            considerations are important and we can help protect
                            the assets you transfer from excessive depletion by
                            understanding these taxes and the various strategies
                            to help you minimize them.
                            <br />
                            <br />
                            Your tax return will be checked and rechecked by our
                            computer software identifying potential problems the
                            IRS may look at more closely and reviewing the math
                            to limit IRS contacts..
                        </p>
                    </div>
                    <img src={Image1} alt="user" />
                </div>

                <AboutCard />
                <div
                    className={`${AboutClasses["section-1"]} ${AboutClasses["section-2"]}`}>
                    <img src={About3} alt="user" />
                    <div
                        className={AboutClasses["content"]}
                        style={{ gap: "0.6rem" }}>
                        {/* <h5>Who we are</h5>{" "} */}
                        <h3>We help get you ahead by following curves</h3>
                        <p>
                            Our experienced staff can develop tax strategies
                            that take advantage of new tax laws and legislation.
                        </p>
                        <ul>
                            <li>Retirement planning</li>
                            <li>Estate planning</li>
                            <li>Education planning</li>
                            <li>Financial planning</li>
                        </ul>
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export default About;
